export const TABELA_LABEL = "Fichas financeiras da obra";
export const COLUNA_CRIADO_EM = "Criado em";
export const COLUNA_STATUS_FEL = "Status FEL";
export const COLUNA_SOLICITANTE = "Solicitante";
export const FICHAS_POR_PAGINA_LABEL = "Fichas por página";
export const FICHAS_CARREGANDO_LABEL = "Carregando fichas...";
export const FICHAS_LIST_TITLE = "Fichas Geradas";
export const GERAR_FICHA_LABEL = "Gerar ficha";
export const GERAR_FICHA_LIST_LABEL = "Gerar Ficha";
export const ABRIR_FICHA_LABEL = "Abrir ficha";
/**
 * Altura máxima da área que rola da tabela dentro da modal: a janela menos a moldura da modal (margem, título, cabeçalho
 * da lista, paginador e respiros). Passando disso o corpo rola por dentro, com o cabeçalho fixo e o paginador à vista.
 */
export const FICHAS_TABELA_ALTURA_MAXIMA = "calc(100vh - 17rem)";
/** Estado vazio conforme o protótipo da modal. */
export const FICHAS_EMPTY_TITLE = "Não há ficha gerada para essa Obra";
export const FICHAS_EMPTY_DESCRIPTION =
  "Clique em Gerar Ficha para preparar uma nova ficha financeira";
